module.exports = __webpack_public_path__ + "static/img/LoginBG.0168dd6d.png";